export enum PublicIssueComplaintType {
  NoProduct = 'NO_PRODUCT',
  DefectiveProduct = 'DEFECTIVE_PRODUCT',
  Other = 'OTHER',
}
